import React, { useMemo } from 'react'
import { ResponsiveLine } from '@nivo/line'
import { ChartTooltip, dashboardChartTheme, thinTicks } from '../charts/theme'

export const ConfirmationGraphic: React.FC<{
  data: any[]
  /** Preenche a área sob a linha. Só faz sentido com uma única série. */
  area?: boolean
  /** Quantos rótulos no máximo no eixo X. */
  maxTicks?: number
  /** Sufixo do valor no balão ("Cadastro(s)", "NFe-s"...). */
  unit?: string
}> = ({ data, area = false, maxTicks = 8, unit }) => {
  const getColor = bar => {
    return data.find(i => i.id === bar.id)?.color || '#222'
  }
  const serieId = (v: string | number) => {
    const i = data.find(i => i.id === v)
    if (i) {
      return i.label
    }
    return ''
  }

  /* Série sem nenhum ponto faz o nivo emitir <path d="null"> e sujar o console
     com erros de SVG. Nunca houve o que desenhar nelas. */
  const series = useMemo(
    () => data.filter(serie => serie?.data?.length),
    [data]
  )

  const tickValues = useMemo(
    () => thinTicks(series, maxTicks),
    [series, maxTicks]
  )

  if (!series.length) {
    return (
      <div className="dash-empty">
        <strong>Sem dados no período</strong>
      </div>
    )
  }

  return (
    <ResponsiveLine
      data={series}
      theme={dashboardChartTheme}
      margin={{ top: 12, right: 16, bottom: 28, left: 38 }}
      xScale={{ type: 'point' }}
      yScale={{
        type: 'linear',
        min: 'auto',
        max: 'auto',
        stacked: false,
        reverse: false
      }}
      enableGridX={false}
      enableGridY
      gridYValues={4}
      axisTop={null}
      axisRight={null}
      axisBottom={{
        tickSize: 0,
        tickPadding: 9,
        ...(tickValues ? { tickValues } : {})
      }}
      axisLeft={{ tickSize: 0, tickPadding: 8, tickValues: 4 }}
      curve="monotoneX"
      colors={getColor}
      useMesh={true}
      enablePoints={false}
      enableArea={area}
      areaOpacity={0.12}
      enableCrosshair
      lineWidth={2}
      tooltip={data => {
        const isDated = String(data.point.data.x)?.indexOf('/') > -1
        return (
          <ChartTooltip color={data.point.serieColor}>
            {isDated ? (
              <strong>{data.point.data.x}</strong>
            ) : (
              serieId(data.point.serieId)
            )}
            :{' '}
            <strong style={{ fontVariantNumeric: 'tabular-nums' }}>
              {data.point.data.y}
            </strong>
            {unit ? ` ${unit}` : isDated ? ' Cadastro(s)' : ''}
          </ChartTooltip>
        )
      }}
    />
  )
}
